import React from "react";

const LOGO_URL = "https://customer-assets-7cd3h4nn.emergentagent.net/job_vg-client-timeline/artifacts/v0dgfz4j_VG_Homes_logo_transparent.png";

export function Logo({ onDark = false, className = "" }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="vg-logo">
      <div className={onDark ? "rounded-lg bg-white px-2.5 py-1.5" : ""}>
        <img src={LOGO_URL} alt="VG Homes" className="h-14 w-auto object-contain" />
      </div>
    </div>
  );
}
